import React from 'react'
import iconFilter from '../../img/icons/icon-filter.png'

export const BtnFilterVer1 = (props) => {
  return (
    <img className='btn_filter_ver_1' onClick={props.onClick} src={iconFilter} alt="" />
  )
}
